export default "__VITE_ASSET__xtE8zZGZ__"